import PreparerSvg from 'assets/icons/Preparer.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(PreparerSvg, { displayName: 'PreparerOutlined' });
